import React from 'react';
import WishListIcon from './WishListIcon';
import styled from 'styled-components';
import { translate } from '../../Services/translation';
import IconText from '../MobileFooterMenu/IconText';

const StyledWishListWrapper = styled.button`
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

const StyledWishListButton = styled.div`
  cursor: pointer;
`;

const WishListButton = () => {

  return (
    <StyledWishListWrapper className='flex flex-col items-center gap-1'>
      <StyledWishListButton
        role="button"
        aria-label={translate('wishlist.title')}
        title={translate('wishlist.title')}
      >
        <WishListIcon />
      </StyledWishListButton>
      <IconText translationKey="general.favorite-desktop" />
    </StyledWishListWrapper>
  );
};

export default WishListButton;
